"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.file_reconciledBusTape = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const tape_builder_base_1 = require("../../../types/tape-builder-base");
const commonTapeNode_1 = require("../../commonTapeNode");
const utils_1 = require("../../utils");
const types_1 = require("./types");
const { isNode, isIntermediateRecord, ...otherProps } = (0, commonTapeNode_1.commonTapeNodeUtils)(types_1.nodeType, types_1.artifactType, types_1.UIConfigSchema);
// create a new UI node of this type.
const createNewNode = ({ id, suggestedSerialNumber, nodeToCopy, }) => {
    const friendlyName = `ReconciledBusTape`;
    const nodeData = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug: `${_.snakeCase(friendlyName)}_${suggestedSerialNumber}`,
            dataTapeSlug: (0, tape_builder_base_1.asArtifactSlugRef)(`data_tape_${suggestedSerialNumber}`),
            msrTapeSlug: (0, tape_builder_base_1.asArtifactSlugRef)(`msr_tape_${suggestedSerialNumber}`),
            enableDataLake: true,
        },
    };
    if (nodeToCopy) {
        nodeData.configuration = (0, utils_1.copyNodeConfiguration)({
            nodeToCopy,
            isNode,
            nodeType: types_1.nodeType,
            suggestedSerialNumber,
        });
    }
    return nodeData;
};
/*
 * validate the configuration for the node. This checks shape as well
 * logical correctness.
 * This function should validate the config wrt rest of the graph as well.
 * if there is an error it should return an array of error messages.
 * if there are no errors it should return an empty array.
 */
const hasValidConfig = ({ node, friendlyName, inputs, outputs, }) => {
    (0, common_1.finleyAssert)(isNode(node), `node must be a ${types_1.nodeType} node`);
    const allowedInputNodes = [
        'file_intermediateTape',
        'file_generatedSupplementalTape',
        'file_rawSupplementalTape',
    ];
    const errors = (0, utils_1.checkEdges)({
        friendlyName,
        inputs,
        outputs,
        isAllowedInputNode: (uiNode) => allowedInputNodes.some((type) => type === uiNode.nodeType),
        minInputs: 1,
        maxInputs: 2,
        minOutputs: 0,
        maxOutputs: 1000,
    });
    return errors;
};
const getTapeDefinition = ({ tapeBuilder, artifactId, }) => {
    const tapeDefinitionResult = tapeBuilder.generateTapeDefinition(artifactId);
    (0, common_1.finleyAssert)(tapeDefinitionResult.isValid, `tapeDefinitionResult is not valid for ${artifactId}`);
    (0, common_1.finleyAssert)(tapeDefinitionResult.data, `No definition found for ${artifactId}`);
    return tapeDefinitionResult.data;
};
// Canonical column names the reconcile step reads at runtime. Deriving them
// from the finley-types schemas keeps this author-time check and the task's
// runtime parse from drifting apart.
//
// Only the REQUIRED slice of the data-tape schema: its metrics-only columns
// (`term`, `remaining_term`, `num_days_delin`) parse leniently to null, so a
// graph that doesn't map them still reconciles — it just renders no term
// averages and an `unknown` delinquency band. Demanding them here would turn a
// reporting nicety into a graph-validation error on every existing deal.
const requiredDataTapeFields = Object.keys(finley_types_1.ReconciledBusTape.ReconciledDataTapeRequiredRowSchema.shape);
const requiredMSRTapeFields = Object.keys(finley_types_1.ReconciledBusTape.ReconciledMsrRowSchema.shape);
/** Assert an input tape definition declares every required column. */
const missingFieldErrors = ({ tapeDefinition, requiredFields, artifactSlug, inputArtifactSlug, }) => {
    const errors = [];
    requiredFields.forEach((field) => {
        const found = tapeDefinition.baseFields.some((baseField) => baseField.field === field);
        if (!found) {
            errors.push(`reconciled-bus-tape: [${artifactSlug}] [inputArtifact:${inputArtifactSlug}] tape definition is missing [field:${field}].`);
        }
    });
    return errors;
};
const validateDataTapeDefinition = ({ tapeDefinition, artifactSlug, inputArtifactSlug, }) => missingFieldErrors({
    tapeDefinition,
    requiredFields: requiredDataTapeFields,
    artifactSlug,
    inputArtifactSlug,
});
const validateMSRTapeDefinition = ({ tapeDefinition, artifactSlug, inputArtifactSlug, }) => missingFieldErrors({
    tapeDefinition,
    requiredFields: requiredMSRTapeFields,
    artifactSlug,
    inputArtifactSlug,
});
const validateIntermediateTape = ({ graph, tape, tapeBuilder, }) => {
    (0, common_1.finleyAssert)(isIntermediateRecord(tape), `validateIntermediateTape: tape is not an ${types_1.artifactType}`);
    (0, common_1.finleyAssert)(tape.type === types_1.artifactType, `node is not a ${types_1.artifactType}`);
    const errors = [];
    const { dataTapeSlug, msrTapeSlug } = tape.configuration;
    const artifactInputs = (0, utils_1.getDirectInputsForArtifact)({
        targetArtifactId: tape.id,
        ...graph,
    });
    const dataTapeInput = artifactInputs.find((input) => input.artifactSlug === dataTapeSlug);
    if (dataTapeInput) {
        const tapeDefinition = getTapeDefinition({
            tapeBuilder,
            artifactId: dataTapeInput.id,
        });
        const dataTapeInputErrors = validateDataTapeDefinition({
            tapeDefinition,
            artifactSlug: tape.artifactSlug,
            inputArtifactSlug: dataTapeSlug,
        });
        errors.push(...dataTapeInputErrors);
    }
    else {
        errors.push(`reconciled-bus-tape: [${tape.artifactSlug}] cannot find [inputArtifact:${dataTapeSlug}] listed as an input dependency.`);
    }
    if (msrTapeSlug) {
        const rawInput = artifactInputs.find((input) => input.artifactSlug === msrTapeSlug);
        if (rawInput) {
            const tapeDefinition = getTapeDefinition({
                tapeBuilder,
                artifactId: rawInput.id,
            });
            const msrTapeInputErrors = validateMSRTapeDefinition({
                tapeDefinition,
                artifactSlug: tape.artifactSlug,
                inputArtifactSlug: msrTapeSlug,
            });
            errors.push(...msrTapeInputErrors);
        }
        else {
            errors.push(`reconciled-bus-tape: [${tape.artifactSlug}] cannot find [inputArtifact:${msrTapeSlug}] listed as an input dependency.`);
        }
    }
    return errors;
};
/**
 * Represents a UI node with various properties and methods.
 */
exports.file_reconciledBusTape = {
    nodeTypeText: 'Reconciled BUS tape',
    nodeType: types_1.nodeType,
    artifactType: types_1.artifactType,
    isOperation: false,
    isRaw: false,
    isFinal: false,
    badgeTexts: ['BackupServicing'],
    createNewNode,
    isNode,
    isIntermediateRecord,
    ...otherProps,
    hasValidConfig,
    validateIntermediateTape,
};
//# sourceMappingURL=uinode.js.map